import { backendApi } from "@/services/backend/api";
import { base64ListRequest } from "@/services/backend/_lib/base64-list-request";
import { Filter } from "@/shared/lib/filter/filter";
import { Lst } from "@/shared/lib/lst/lst";

const processMatchApi = backendApi
  .enhanceEndpoints({
    addTagTypes: ["DynamicsProcessMatch"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      dynamicssalesPutProcessMatch: build.mutation<PutResponse, Match>({
        query: (request) => ({
          url: `dynamics/process-match`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: ["DynamicsProcessMatch"],
      }),
      dynamicssalesListProcessMatch: build.query<Lst<Match>, ListRequest>({
        query: (request) => ({
          url: `dynamics/process-match/list`,
          method: "GET",
          params: base64ListRequest(request),
        }),
        providesTags: ["DynamicsProcessMatch"],
      }),
      dynamicssalesDeleteProcessMatch: build.mutation<null, DeleteRequest>({
        query: (request) => ({
          url: `dynamics/process-match`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: ["DynamicsProcessMatch"],
      }),
      dynamicssalesListOpportunityLink: build.query<
        Lst<OpportunityLink>,
        OpportunityLinkRequest
      >({
        query: (request) => ({
          url: `dynamics/process-match/opportunity-link-list`,
          method: "GET",
          params: request,
        }),
        providesTags: ["DynamicsProcessMatch"],
      }),
    }),
  });

export const {
  useDynamicssalesPutProcessMatchMutation,
  useDynamicssalesListProcessMatchQuery,
  useDynamicssalesDeleteProcessMatchMutation,
  useDynamicssalesListOpportunityLinkQuery,
} = processMatchApi;

export interface Match {
  processId: string;
  opportunityId: string;
  name: string;
  stateCode: number;
  statusCode: number;
  newUnternehmensgruppe: number;
  axNiederlassung: number;
  axDienstleistung: number;
  accountId: string;
  createdOn: string;
  modifiedOn: string;
}

export interface PutResponse extends Match {
  matchIsNew: boolean;
}

export interface ListRequest {
  process?: Filter<string>;
  opportunity?: Filter<string>;
  limit?: number;
  offset?: number;
}

export interface DeleteRequest {
  processId: string;
}

export interface OpportunityLink {
  opportunityId: string;
  link: string;
}

export interface OpportunityLinkRequest {
  processId: string;
}
